import React, { Component } from 'react';

import classes from './ImageUploader.module.css';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Buttons/Button';
import axios from '../../axiosdata';
import { updateObject, checkValidation } from '../../shared/utility';
import { connect } from 'react-redux';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"


class ImageUploader extends Component {
    
    state = {
        booksForm: {
            link: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'esim. https://wapina.fi/'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 2
                },
                valid: false,
                touched: false
            }
        },
        formIsValid: false,
        selectedFile: null,
        url: null,
        imageUploaded: false,
        disabled: true,
        missingInfo: false,
        uploadError: null
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedFormElement = updateObject(this.state.booksForm[inputIdentifier], {
            value: event.target.value,
            valid: checkValidation(event.target.value, this.state.booksForm[inputIdentifier].validation),
            touched: true
        });
        
        const updatedBooksForm = updateObject(this.state.booksForm, {
            [inputIdentifier]: updatedFormElement
        });
        
        let formIsValid = true;
        for (let inputIdentifier in updatedBooksForm) {
            formIsValid = updatedBooksForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({booksForm: updatedBooksForm, formIsValid: formIsValid});
        
    }
    fileSelectedHandler = event => {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = ['image/png', 'image/svg+xml', 'image/jpeg', 'image/webp'];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(file.type)) {
            this.setState({ uploadError: 'Vain kuvatiedostot sallittu (PNG, SVG, JPG, WEBP).' });
            return;
        }
        if (file.size > maxSize) {
            this.setState({ uploadError: 'Tiedosto on liian suuri (max 5MB).' });
            return;
        }

        this.setState({ selectedFile: file, imageUploaded: true, uploadError: null });
    }

    saveInformationToFireBase = (event) =>{
        event.preventDefault();
        if(this.state.formIsValid && this.state.imageUploaded){
            this.SaveBookImageToFireBase();
        } else {
            this.setState({missingInfo: true})
        }

    }

    SaveBookImageToFireBase = () =>{
        const image = this.state.selectedFile;
        const storage = getStorage();
        const storageRef = ref(storage, `sponsors/${image.name}`);
        const uploadTask = uploadBytesResumable(storageRef, image);

        uploadTask.on('state_changed',
            () => {
                // Progress tracking could be added here
            },
            (error) => {
                console.error('Image upload error:', error.code, error.message);
                this.setState({ uploadError: `Kuvan lataus epäonnistui (${error.code}). Tarkista verkkoyhteytesi ja yritä uudelleen.` });
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    this.setState({ url: url, uploadError: null }, () => {
                        this.SaveBookToFireBase();
                    });
                }).catch((error) => {
                    console.error('Failed to get download URL:', error);
                    this.setState({ uploadError: 'Kuvan URL:n haku epäonnistui.' });
                });
            }
        );
    }

    SaveBookToFireBase = () => {
        const formData = {
            image: this.state.url,
            link: {},
        };
        for (let formElementIdentifier in this.state.booksForm) {
            formData.link[formElementIdentifier] = this.state.booksForm[formElementIdentifier].value;
        }

        axios.post('/sponsors.json', formData)
        .then(() => this.props.onSuccess())
        .catch(err => {
            console.error('Failed to save sponsor to database:', err);
            this.setState({ uploadError: 'Tietojen tallennus epäonnistui. Tarkista että olet kirjautunut sisään.' });
        });
    } 

    disableButton = () =>{
        this.setState({disabled: false})
    }

    render () {
        const formElementsArray = [];
        let missingInfoWarning = '';
        let errorMessage = '';

        if (this.state.missingInfo){
            missingInfoWarning = <div className={classes.warning}>Anna kaikki tarvittavat tiedot!</div>;
        }

        if (this.state.uploadError){
            errorMessage = <div className={classes.warning}>{this.state.uploadError}</div>;
        }
            
        for (let key in this.state.booksForm) {
            formElementsArray.push({
                id: key,
                config: this.state.booksForm[key]
            });
        }
        let form = (
            <div>   
                <form onSubmit={this.saveInformationToFireBase}>
                {formElementsArray.map(formElement =>(
                    <Input 
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)}/>
                ))}
                {missingInfoWarning}
                {errorMessage}
                    <Button>Tallenna</Button>
                </form>  

            </div>
        );

        return (
                <div className={classes.ContactData}>
                    <div className={classes.Title}>
                        <h4>Lisää uusi yhteistyökumppani</h4>
                    </div>
                    <div className={classes.ImageUpload}>
                            <h4>Lataa kuva (muodossa png/svg)</h4>
                        <div className={classes.InputElement}>
                            <input type="file" onChange={this.fileSelectedHandler}/>
                        </div>
                            <h4>Linkki yhteistyökumppanin sivuille</h4>
                        {form}
                    </div>
                </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    }
}

export default connect(mapStateToProps)(ImageUploader);
